<template>
  <div>
    <h3>Dataset Description</h3>
    <el-table
        style="margin: auto; width: 90%"
        :data="datasetDetails"
        :header-cell-style="{margin: '0',padding: '0', color: 'black'}"
        :cell-style="{margin: '0',padding: '0', color: 'black'}"
        stripe
        border>
      <el-table-column
          prop="title"
          label="title"
          min-width="30px">
      </el-table-column>
      <el-table-column
          prop="content"
          label="content">
      </el-table-column>
    </el-table>
    <br/>
    <h3>Dataset Detail</h3>
    <br/>
    <MyGridLayout :layout-data="layoutData" v-if="isGridShow"/>
    <div>
      <Liver :asyncData="datasetInfo" v-if="isLiver"></Liver>
    </div>
  </div>
</template>

<script>
import Liver from "@/components/Dataset/Overview_folder/Liver";
import MyGridLayout from "@/components/tools/MyGridLayout";

export default {
  name: "Overview_grid",
  components: {
    MyGridLayout,
    Liver,
  },
  data() {
    return {
      datasetDetails: [],
      isGridShow: false,
      layoutData: [
        // { x: 0, y: 0, w: 4, h: 15, i: "0", type: "TruthImageCard", data:{picText: "asd", groundtruth_source: "http://43.138.27.12:8081/file/20210101/IDC/groundtruth.png"} },
        // { x: 4, y: 0, w: 4, h: 15, i: "1", type: "InfoCard", data:{info: {types: [], spotSize: 1, tip: [], source: []}, info_type: "spatial domain"} },
        // { x: 8, y: 0, w: 4, h: 15, i: "2", type: "InfoCard", data:{info: {types: [], spotSize: 1, tip: [], source: []}, info_type: "celltype"} },
        // { x: 0, y: 1, w: 4, h: 15, i: "3", type: "InfoCard", data:{info: {types: [], spotSize: 1, tip: [], source: []}, info_type: "celltype_major"} },
        // { x: 4, y: 1, w: 4, h: 15, i: "4", type: "InfoCard", data:{info: {types: [], spotSize: 1, tip: [], source: []}, info_type: "celltype_minor"} },
        // { x: 8, y: 1, w: 4, h: 15, i: "5", type: "InfoCard", data:{info: {types: [], spotSize: 1, tip: [], source: []}, info_type: "celltype_subset"} },
      ],
      COLOR_ALL: [
        '#37A2DA',
        '#e06343',
        '#37a354',
        '#b55dba',
        '#b5bd48',
        '#8378EA',
        '#96BFFF',
        '#E72178',
        '#354E6C','#EAAC31',
        '#EAD2AE',
        '#127678','#30B5A4','#B4D9D2',
        '#354581','#FFE074',
        '#E03C79','#88C1B8',
        '#FC6746','#F5B307','#008186'
      ],
      groundtruth_source: '',
      formData: {
        datasetID: '',
        Array:  '',
      },
      echart_info: {
        classification_info: {
          types: [],
          spotSize: 3,
          tip: [],
          source: []
        },
        annot_type_info: {
          types: [],
          spotSize: 3,
          tip: [],
          source: []
        },
        fine_annot_type_info: {
          types: [],
          spotSize: 3,
          tip: [],
          source: []
        },
        celltype_info: {
          types: [],
          spotSize: 3,
          tip: [],
          source: []
        },
        major_info: {
          types: [],
          spotSize: 3,
          tip: [],
          source: []
        },
        minor_info: {
          types: [],
          spotSize: 3,
          tip: [],
          source: []
        },
        subset_info: {
          types: [],
          spotSize: 3,
          tip: [],
          source: []
        }
      },
      isLiver: false,
    }
  },
  props:{
    asyncData: {
      classification_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      annot_type_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      fine_annot_type_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      celltype_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      major_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      minor_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      subset_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
    },
    datasetInfo: Array,
    asynPicText: String,
    asynGround: String,
  },
  mounted() {
    // this.$gridlayout.load();
    // this.index = this.layout.length;
    this.echart_info = this.asyncData
    this.groundtruth_source = this.asynGround
    this.formData.datasetID = this.datasetInfo[0].datasetID
    this.formData.Array = this.datasetInfo[0].name
    this.getDatasetInformation()
    this.$nextTick(function () {
      if (this.formData.datasetID.toString() === '20210602'){
        this.isLiver = true
      }
      // console.log(this.isLiver)
      this.initLayoutData()
    })
  },
  methods: {
    getDatasetInformation() {
      let _this = this
      // console.log(_this.formData.datasetID)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/dataset/'+ _this.formData.datasetID)
          .then(function (response){
            // console.log("dataset:")
            // console.log(response)
            _this.datasetDetails = response.data.details
          })
    },
    initLayoutData: function () {
      let index = 0
      let temp_layout = []
      if (this.asynGround !== '' || this.asynGround.length !== 0){
        temp_layout.push({
          x: Math.round((index % 3) * 4),
          y:  Math.round(index / 3),
          w: 4,
          h: 15,
          i: 'overview'+index.toString(),
          type: "TruthImageCard",
          data:{
            datasetID: this.formData.datasetID,
            groundtruth_source: this.asynGround
          }
          },)
        index++
      }
      let item;
      for(item in this.echart_info) {
        if (this.echart_info[item].source.length !== 0){
          let info_pic = ''
          switch (item) {
            case 'classification_info':
              info_pic = 'spatial domain';
              break;
            case 'annot_type_info':
              info_pic = 'anno_true';
              break;
            case 'fine_annot_type_info':
              info_pic = 'fine_anno_true';
              break;
            case 'celltype_info':
              info_pic = 'celltype';
              break;
            case 'major_info':
              info_pic = 'celltype_major';
              break;
            case 'minor_info':
              info_pic = 'celltype_minor';
              break;
            case 'subset_info':
              info_pic = 'celltype_subset';
              break;
          }
          // console.log(item)
          // console.log(this.echart_info[item])
          // console.log(info_pic)
          temp_layout.push({
            x: Math.round((index % 3) * 4),
            y: Math.round(index / 3),
            w: 4,
            h: 15,
            i: 'overview'+index.toString(),
            type: "InfoCard",
            data:{
              info: this.echart_info[item],
              info_type: info_pic
            },
          },)
          index++;
        }
      }
      for(item in this.echart_info) {
        if (this.echart_info[item].source.length !== 0){
          temp_layout.push({
            x: Math.round((index % 3) * 4),
            y: Math.round(index / 3),
            w: 4,
            h: 15,
            i: 'overview'+index.toString(),
            type: "PieCard",
            data:{
              info: this.echart_info[item],
              info_type: item
            },
          },)
          index++;
        }
      }
      // console.log("temp_layout")
      // console.log(temp_layout)
      this.layoutData = temp_layout
      this.isGridShow = true
    }

  }
}
</script>

<style scoped>

</style>
